import { Component, EventEmitter, HostBinding, Input, Output } from "@angular/core";
import { RideOpsUiService } from "source/app/configuration/services/rideops-ui.service";

@Component({
	selector: "app-offline-message",
	templateUrl: "./offline-message.component.html",
	styleUrls: ["./offline-message.component.scss"],
})
export class OfflineMessageComponent {
	constructor(private rideOpsUi: RideOpsUiService) {}

	@Input() showRetry: boolean;
	@Output() retry = new EventEmitter<void>();

	@HostBinding("class.offline-message--v2")
	get isV2(): boolean {
		return this.rideOpsUi.isV2Active();
	}
}
